import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import RenterDashboardComponent from './renter-dashboard-component';
import OwnerDashboardComponent from './owner-dashboard-component';

import { getBookings } from '../bookings/actions';

const mapStateToProps = state => ({
  user: state.Dashboard.user,
  booking: state.Booking
});

class DashboardComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeDashboard: '',
      ratingFormValues: {
        title: '',
        id: null,
        type: ''
      }
    }

    this.setActiveDashboard = this.setActiveDashboard.bind(this);
  }

  componentWillMount() {
    let { dispatch } = this.props;
    dispatch(getBookings());
  }

  componentDidUpdate(oldProps) {
    if (this.props.user && !this.state.activeDashboard) {
      this.setActiveDashboard(this.props.user.userType);
    }
  }

  setActiveDashboard(type) {
    this.setState({ activeDashboard: type });
  }

  render() {
    let { user } = this.props;
    let { activeDashboard } = this.state;

    if (!user || !activeDashboard)
      return (<div className="container text-center"><h4>Loading...</h4></div>)
    let dashboard = null;
    if (activeDashboard === "renter") {
      dashboard = (<RenterDashboardComponent setActive={this.setActiveDashboard} />)
    } else {
      dashboard = (<OwnerDashboardComponent setActive={this.setActiveDashboard} />)
    }
    return (
      <div>
        {dashboard}
      </div>
    )
  }
}

export default connect(mapStateToProps)(DashboardComponent);
